import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../variables';

const Dropdown = ({ isOpen, setIsOpen, children, width, className }) => {
  if (isOpen) {
    return <div className={className}>{children}</div>;
  } else {
    return null;
  }
};

// === Dropdown CSS ===
const StyledDropdown = styled(Dropdown)`
  --dropdown-border-width: 1px;
  --checkbox-input-spacing: 0.6rem;

  position: absolute;
  margin-top: calc(-1 * var(--dropdown-border-width));
  padding: ${vars.spacingS} ${vars.spacingM} ${vars.spacingS} ${vars.spacingS};
  background-color: ${vars.white};
  border: var(--dropdown-border-width) solid ${vars.borderGrey};
  ${({ width }) => (width ? `width: ${width};` : null)}
  z-index: 70;

  animation: fadeIn linear ${vars.defaultTransitionDuration};

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .input-element:not(:last-of-type) {
    margin-bottom: var(--checkbox-input-spacing);
  }
`;

export default StyledDropdown;
